import { render, staticRenderFns } from "./SidebarAdmin.vue?vue&type=template&id=7d387e73&scoped=true&"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js&"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAdmin.vue?vue&type=style&index=0&id=7d387e73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d387e73",
  null
  
)

export default component.exports